import React, { useEffect, useState } from "react";
import {
  Avatar,
  Backdrop,
  Button,
  FormFieldSet,
  LogoLoader,
  NewTableAdv,
  PageHeader,
  PageTitle,
  showToast,
  StatusTags,
} from "../../../components";
import qbLoading from "../../../assets/qbLoading.svg";
import cloud_alert from "../../../assets/cloud_alert.svg";
import cloud_done from "../../../assets/cloud_done.svg";
import { dateFormator, formatNumber, mapTableRows } from "../../../utils";
import QbDocument from "../../../components/Module/Invoices/InvoiceModals/QbDocument";
import { useDispatch, useSelector } from "react-redux";
import { qbApiStart } from "../../../redux/slices/quickBooks/quickBooksSlice";
import { usePagination } from "../../../hooks";
import { totalCountStart } from "../../../redux/slices/totalCount/totalCountSlice";
import {
  addInvoicesStart,
  clearInvoicesdata,
  getAllInvoicesStart,
} from "../../../redux/slices/invoices/invoicesSlice";
import QbAnimationLoading from "../../../components/Module/Invoices/InvoiceModals/QbAnimationLoading";
import { WORKFORCE_API_URL } from "../../../redux/apiConfig";
import axios from "axios";

const InvoicesFromQb = () => {
  const [uploadQb, setUploadQb] = useState(false);
  const dispatch = useDispatch();
  const { value } = useSelector((state) => state.totalCount);
  const totalCount = value?.invoices?.data || 0;
  const { allInvoices, loading } = useSelector((state) => state.invoices);
  const isLoading = loading;
  const allInvoicesTableData = allInvoices?.data || [];
  console.log("allInvoicesTableData", allInvoicesTableData);

  const [sortConfig, setSortConfig] = useState({ field: "uiid", direction: 1 });
  const [selectedRowIds, setSelectedRowIds] = useState([]);
  const [forceRerenderKey, setForceRerenderKey] = useState(0);
  const [qbLoading, setQbLoading] = useState(false);

  const { page, limit, setPage, handleLimitChange } = usePagination(
    10,
    (newPage, newLimit) => {
      // dispatch(getAccountPayablesStart({ page: newPage, limit: newLimit }));
    }
  );

  const tableData = [
    {
      client: "Entrans Inc",
      invoiceNumber: "16500",
      paymentDate: "2025-04-20T18:30:00.000Z",
      referenceNumber: "--",
      receivedAmount: "10912.00 USD",
    },
    {
      client: "Entrans Inc",
      invoiceNumber: "16500",
      paymentDate: "2025-04-20T18:30:00.000Z",
      referenceNumber: "--",
      receivedAmount: "10912.00 USD",
    },
    {
      client: "VDart Inc",
      invoiceNumber: "16500",
      paymentDate: "2025-04-20T18:30:00.000Z",
      referenceNumber: "--",
      receivedAmount: "10912.00 USD",
    },
    {
      client: "VDart Inc",
      invoiceNumber: "16500",
      paymentDate: "2025-04-20T18:30:00.000Z",
      referenceNumber: "--",
      receivedAmount: "10912.00 USD",
    },
  ];
  //as per design
  // const columns = [
  //   {
  //     key: "client",
  //     label: "Client",
  //     render: (row) => (
  //       <div className="cursor-pointer flex gap-2 items-center">
  //         <Avatar
  //           src={true ? cloud_done : cloud_alert}
  //           alt=""
  //           outline
  //           className="border-none"
  //           size="xs-sm"
  //         />
  //         {/* <Button type="icon" icon={false ? "cloud_alert": "cloud_done"} variant="text" color="black" /> */}
  //         {row.client}
  //       </div>
  //     ),
  //   },
  //   {
  //     key: "invoiceNumber",
  //     label: "Invoice Number",
  //   },
  //   {
  //     key: "paymentDate",
  //     label: "Payment Date",
  //     render: (row) => dateFormator(row.paymentDate, "month-day-year"),
  //   },
  //   {
  //     key: "referenceNumber",
  //     label: "Reference Number",
  //   },
  //   {
  //     key: "receivedAmount",
  //     label: "Received Amount",
  //     render: (row) => <div>{formatNumber(row.receivedAmount)}</div>,
  //   },
  //   // {
  //   //   key: "Actions",
  //   //   label: "Actions",
  //   //   render: (row) => (
  //   // <div className="cursor-pointer">
  //   //   <Avatar
  //   //     src={qbLoading}
  //   //     alt=""
  //   //     outline
  //   //     className="border-none"
  //   //     size="xs"
  //   //   />
  //   // </div>
  //   //   ),
  //   // },
  // ];
  //for now
  const columns = [
    {
      key: "invoiceNumber",
      label: "Invoice Number",
      render: (row) => (
        <div className="cursor-pointer flex gap-2 items-center">
          <Avatar
            src={row.qbSync?.id ? cloud_done : cloud_alert}
            // src={
            //   row?.qbSync?.status === 1
            //     ? cloud_alert
            //     : row?.qbSync?.status === 2
            //     ? cloud_done
            //     : cloud_alert
            // }
            alt=""
            outline
            className="border-none"
            size="xs-sm"
            // size="xs"
            // size="sm"
          />
          {/* <Button type="icon" icon={false ? "cloud_alert": "cloud_done"} variant="text" color="black" /> */}
          {row.invoiceNumber}
        </div>
      ),
      // sortable: false,
    },

    {
      key: "businessUnit",
      label: "Business Unit",
      sortable: false,
    },
    {
      key: "recordType",
      label: "Record Type",
      sortable: false,
    },
    {
      key: "clientName",
      label: "Client Name",
      sortable: false,
    },
    {
      key: "employeeName",
      label: "Employee Name",
      sortable: false,
    },
    {
      key: "invoicDate",
      label: "Invoic Date",
      sortable: false,
    },
    {
      key: "dueDate",
      label: "Due Date",
      sortable: false,
    },
    {
      key: "statementMemoPeriod",
      label: "Statement Memo Period",
      sortable: false,
    },
    {
      key: "invoiceAmount",
      label: "Invoice Amount",
      sortable: false,
    },
    {
      key: "receivedAmount",
      label: "Received Amount",
      sortable: false,
    },
    {
      key: "status",
      label: "Status",
      render: (row) => <StatusTags tag={row.status} />,
      sortable: false,
    },
    {
      key: "syncstatus",
      label: "Sync Status",
      sortable: false,
    },
  ];
  useEffect(() => {
    dispatch(
      totalCountStart({
        collection: "invoices",
        coll: "Invoice",
        //filters: item.filters,
      })
    );
    dispatch(
      getAllInvoicesStart({
        limit,
        page,
        filters: {},
        coll: "Invoice",
        // ret:"uiid"
        // ret: "invoiceNum clientId invoiceDate dueDate uiid",
        ret: "",
        ref: "Client Employee",
        // incl: ["businessName uiid qbSync", "firstName lastName"],
        incl: ["", "firstName lastName"],
      })
    );
    return () => {
      dispatch(clearInvoicesdata());
    };
  }, [dispatch, page, limit, sortConfig, forceRerenderKey]);

  //get of the qb data
  // useEffect(() => {
  //   const fetchInvoices = async () => {
  //     dispatch(
  //       qbApiStart({
  //         method: "GET",
  //         entity: "invoices",
  //         params: {
  //           //working
  //           // lim: limit * page,
  //           // pg:1,
  //           lim: 1000,
  //         },
  //         // body: {
  //         //
  //         // },
  //       })
  //     );
  //   };
  //   fetchInvoices();
  // }, [page,limit]);

  const tableData2 =
    allInvoicesTableData?.map((invoice) => ({
      id: invoice?.uiid,
      uiid: invoice?.uiid,
      invoiceNumber: invoice?.invoiceNum || "-",
      businessUnit: "-",
      recordType: "-",
      clientName: invoice?.clientId?.businessName || "-",
      employeeName:
        invoice?.employeeId?.firstName + " " + invoice?.employeeId?.lastName ||
        "-",
      invoicDate: dateFormator(invoice?.invoiceDate, "month-day-year") || "-",
      dueDate: dateFormator(invoice?.dueDate, "month-day-year") || "-",
      // statementMemoPeriod: "05/1/2025-05/31/2025",
      statementMemoPeriod:
        `${dateFormator(
          invoice?.memoPeriod?.from,
          "month-day-year"
        )} - ${dateFormator(invoice?.memoPeriod?.to, "month-day-year")}` ||
        "-",
      invoiceAmount: invoice?.amounts?.invoiced
        ? `${invoice?.amounts?.invoiced} USD`
        : "-" || "-",
      receivedAmount: invoice?.amounts?.received
        ? `${invoice?.amounts?.received} USD`
        : "-" || "-",
      // status: "Submitted",
      status:
        invoice?.status === 1
          ? "draft"
          : invoice?.status === 2
          ? "sent"
          : invoice?.status === 3
          ? "paid"
          : invoice?.status === 4
          ? "overdue"
          : "cancelled" || "-",
      syncstatus:
        invoice?.qbSync?.status === 1
          ? "Not-Synced"
          : invoice?.qbSync?.status === 2
          ? "Synced"
          : "Partial-Synced",
      qbSync: invoice?.qbSync,
    })) || [];
  // const mappedRows = mapTableRows(tableData, columns);
  const mappedRows = mapTableRows(tableData2, columns);

  const forceRerender = () => {
    console.log("F render:::::");
    setForceRerenderKey((prevKey) => prevKey + 1);
  };

  const handleUpdate = async (entity) => {
    if (selectedRowIds.length === 0) {
      showToast("Please select at least one invoice", "info", 5000);

      return;
    }

    let baseUrl = WORKFORCE_API_URL;

    try {
      setQbLoading(true);

      const selectedIds = selectedRowIds;

      const invoiceData = allInvoicesTableData?.filter((invoice) =>
        selectedIds.includes(invoice.uiid)
      );

      let successCount = 0;

      let failedCount = 0;

      const buildClientPayload = (data) => ({
        postActions: ["AddQBToClient"],

        payload: {
          // businessName: data.businessName || "",
          businessName: data?.businessName || "",
          uiid: data?.uiid || null,
          email: data?.email || [],
          phone: (data?.phone || []).map((p) => ({
            code: p.code || "",
            number: String(p.number || ""),
          })),
          roleContacts: (data?.roleContacts || []).map((rc) => ({
            role: rc.role || "",
            email: rc.email || [],
            phone: (rc.phone || []).map((p) => ({
              code: p.code || "",
              number: String(p.number || ""),
            })),
          })),
          federalId: data?.federalId || "",
          website: data?.website || "",
          recordStatus: data?.recordStatus || null,
          ownership: data?.ownership || null,
          generalInfo: data?.generalInfo || null,
          contacts: data?.contacts || [],
          additionalInfo: data?.additionalInfo || "",
          documents: (data?.documents || []).map((doc) => ({
            placement: doc.placement || [],
            list: doc.list || [],
          })),
          placements: data?.placements || [],
          addedBy: data?.addedBy || null,
          addedOn: data?.addedOn || new Date().toISOString(),
        },
      });

      const buildInvoicePayload = (invoice) => {
        const obj = invoice;

        return {
          ...(obj?.qbSync?.id && { qbSync: obj?.qbSync }),
          uiid: obj?.uiid,
          // clientId: 24,
          clientId: obj?.clientId.uiid || null,
          invoiceCreatedBy: obj?.invoiceCreatedBy || null,
          invoiceNum: obj?.invoiceNum || null,
          poNum: obj?.poNum || null,
          type: obj?.type || null,
          frequency: obj?.frequency || null,
          frequencyPeriod: obj?.frequencyPeriod || null,
          status: obj?.status || null,
          inclPOEmail: obj?.inclPOEmail || null,
          employeeId: obj?.employeeId._id || null,
          jobId: obj?.jobId._id || null,
          timesheet: obj?.timesheet || null,
          address: {
            billing: {
              ...(obj?.address.billing || null),
              zipCode: obj?.address.billing.zipCode || "",
            },
            from: {
              ...(obj?.address.from || null),
              zipCode: obj?.address.from.zipCode || "",
            },
          },
          netTerms: obj?.netTerms || null,
          // invoiceDate:
          //   invoiceDate >= minAllowed
          //     ? invoiceDate.toISOString()
          //     : minAllowed.toISOString(),
          invoiceDate: obj?.invoiceDate || null,
          shippedDate: obj?.shippedDate || null,
          dueDate: obj?.dueDate || null,
          location: obj?.location || null,
          amounts: obj?.amounts || null,
          recipients: obj?.recipients || null,
          serviceSummary: obj?.serviceSummary.map(
            ({ ss, activity, quantity, rate, attachments, inclMailAttch }) => ({
              ss,
              activity,
              quantity,
              rate,
              amount: +(Number(quantity) * Number(rate)).toFixed(2),
              attachments,
              inclMailAttch,
            })
          ),
          finalBill: {
            subTotal: obj?.finalBill.subTotal || null,
            discounts: obj?.finalBill.discounts.map(
              ({ name, type, value }) => ({
                name,
                type,
                value,
              })
            ),
          },
          notes: obj?.notes || null,
          inclNotesPdf: obj?.inclNotesPdf || null,
          memo: obj?.memo || null,
          memoPeriod: obj?.memoPeriod || null,
          additionalInfo: obj?.additionalInfo || null,
          currency: obj?.currency || null,
          addedBy: obj?.addedBy || null,
          addedOn: obj?.addedOn || null,
          attachments: [],
          payableTo: "",
          category: "",
          class: "",
        };
      };

      for (const invoice of invoiceData) {
        const clientData = invoice.clientId || {};

        const isClientSynced = Boolean(clientData?.qbSync?.id);

        if (!isClientSynced) {
          try {
            const clientPayload = buildClientPayload(clientData);

            await axios.post(`${baseUrl}/qb/customers`, clientPayload, {
              headers: { "Content-Type": "application/json" },

              withCredentials: true,
            });
          } catch (err) {
            showToast(
              `${err?.response?.data?.error || "Unknown error"}`,

              "warning",

              5000
            );

            console.error("Customer Sync Failed:", err.response || err);

            failedCount++;

            continue;
          }
        }

        const isInvoiceSynced = Boolean(invoice?.qbSync?.id);

        const invoicePayload = buildInvoicePayload(invoice);

        try {
          if (!isInvoiceSynced) {
            const res = await axios.post(
              `${baseUrl}/qb/${entity}`,

              {
                postActions: ["AddQBToInvoice"],

                payload: invoicePayload,
              },

              {
                withCredentials: true,

                headers: { "Content-Type": "application/json" },
              }
            );
            let failedUploads = 0;

            if (
              invoicePayload?.serviceSummary?.length > 0 ||
              invoicePayload?.serviceSummary?.some(
                ({ attachments }) => attachments?.length > 0
              )
            ) {
              for (const service of invoicePayload.serviceSummary) {
                if (service?.attachments?.length > 0) {
                  for await (const file of service.attachments) {
                    try {
                      const filesRes = await axios.post(
                        `${baseUrl}/qb/uploads`,
                        {
                          payload: {
                            uiid: invoicePayload.uiid,
                            fileName: service?.ss,
                            inclToMail: !!service.inclMailAttch,
                            parentRef: {
                              entity: "Invoice",
                              id: res?.data?.data?.response?.Id,
                            },
                            attachment: file,
                          },
                        },
                        {
                          headers: { "Content-Type": "application/json" },
                          withCredentials: true,
                        }
                      );
                    } catch (err) {
                      failedUploads++;
                    }
                  }
                }
              }
              if (failedUploads > 0) {
                dispatch(
                  addInvoicesStart({
                    coll: "Invoice",
                    uiid: invoicePayload?.uiid,
                    qbId: res?.data?.data?.response?.Id,
                    syncFromQB: true,
                    supressToast: true,
                    onSuccess: () => {
                      forceRerender();
                    },
                  })
                );
                showToast(
                  `${failedUploads} attachment${
                    failedUploads > 1 ? "s" : ""
                  } failed to upload`,
                  "info",
                  3000
                );
              } else {
                dispatch(
                  addInvoicesStart({
                    coll: "Invoice",
                    uiid: invoicePayload?.uiid,
                    qbId: res?.data?.data?.response?.Id,
                    syncFromQB: true,
                    supressToast: true,
                    onSuccess: () => {
                      forceRerender();
                    },
                  })
                );
              }
            }

            successCount++;
          } else {
            const res = await axios.post(
              `${baseUrl}/qb/${entity}`,

              {
                update: true,

                postActions: ["AddQBToInvoice"],

                payload: invoicePayload,
              },

              {
                withCredentials: true,

                headers: { "Content-Type": "application/json" },
              }
            );

            // dispatch(
            //   addInvoicesStart({
            //     coll: "Invoice",
            //     uiid: invoicePayload?.uiid,
            //     qbId: invoicePayload?.qbSync?.id,
            //     syncFromQB: true,
            //     supressToast:true
            //   })
            // );
            successCount++;
          }
        } catch (err) {
          showToast(
            `${err?.response?.data?.error || "Unknown error"}`,

            "warning",

            5000
          );

          console.error("Invoice Sync Error:", err);

          failedCount++;
        }
      }

      showToast(
        `QB Update Done: ${successCount} succeeded, ${failedCount} failed.`,

        failedCount > 0 ? "warning" : "success",

        6000
      );
    } catch (err) {
      console.error("Unexpected QB Sync Error:", err);

      showToast("Unexpected Error Occurred", "error", 5000);
    } finally {
      setQbLoading(false);

      forceRerender();
    }
  };
  const handleQbDispatchSync = async () => {
    try {
      setQbLoading(true);
      if (selectedRowIds.length === 0) {
        showToast("Please select at least one invoice", "info", 5000);
        return;
      }

      const selectedIds = selectedRowIds;
      const invoiceData = allInvoicesTableData?.filter((invoice) =>
        selectedIds.includes(invoice.uiid)
      );

      let successCount = 0;
      let notSyncedCount = 0;

      for (const invoice of invoiceData) {
        if (!invoice?.qbSync?.id) {
          notSyncedCount++;
          continue;
        }

        try {
          await new Promise((resolve) => {
            dispatch(
              addInvoicesStart({
                coll: "Invoice",
                uiid: invoice?.uiid,
                qbId: invoice?.qbSync?.id,
                syncFromQB: true,
                supressToast: true,
                onSuccess: () => {
                  successCount++;
                  resolve();
                },
              })
            );
          });
        } catch (error) {
          console.error("Error during sync", error);
        }
      }

      showToast(
        `QB Sync Completed: ${successCount} succeeded, Update ${notSyncedCount} Invoice's to sync`,
        successCount > 0 ? "success" : "warning",
        4000
      );
    } catch (error) {
      console.error("Error during sync", error);
    } finally {
      setQbLoading(false);
      forceRerender();
    }
  };
  return (
    <div className="py-8 px-3">
      <Backdrop isOpen={loading}>
        <LogoLoader />
      </Backdrop>
      <div className="mb-8">
        <PageHeader
          Section={
            <div className="flex">
              <PageTitle title={"QuickBooks - Invoices"} tag="h6" />
            </div>
          }
          RightSection={
            <>
              <div className="flex border border-primary-600 gap-2 items-center px-2 rounded-md py-1 cursor-pointer">
                <Avatar
                  src={qbLoading}
                  alt=""
                  outline
                  className="border-none"
                  size="xs"
                />
                <p className="sub-category-meadium font-medium text-primary">
                  Tek Tree LLC
                </p>
              </div>
              <Button
                title="Back"
                size="sm"
                // icon={"arrow_left_alt"}
                onClick={() => window.history.back()}
              />
            </>
          }
        />
      </div>
      <div className="mb-3">
        <PageHeader
          Section={
            <div className="flex">
              <FormFieldSet
                type="search"
                placeholder="invoice No ,Client ,Employee"
                noTitle
              />
            </div>
          }
          RightSection={
            <>
              <Button
                title="Update"
                size="sm"
                // icon={"arrow_left_alt"}
                onClick={() => handleUpdate("invoices")}
                // disabled={true}
              />
              <Button
                title="Import"
                size="sm"
                // icon={"arrow_left_alt"}
                onClick={() => handleQbDispatchSync()}
              />
              {/* <Button
                title="Import / Updates"
                size="sm"
                // icon={"arrow_left_alt"}
                onClick={() => handleUpdate("invoices")}
              /> */}
            </>
          }
        />
      </div>
      <div>
        <NewTableAdv
          onSelectionChange={(ids) => setSelectedRowIds(ids)}
          columns={columns}
          rows={mappedRows}
          showCheckbox
          serverPagination={true}
          totalCount={totalCount}
          page={page}
          limit={limit}
          onPageChange={setPage}
          onLimitChange={handleLimitChange}
          toolbarRight={{
            search: false,
          }}
        />
      </div>
      <div>
        {/* <QbDocument isOpen={uploadQb} onClose={() => setUploadQb(false)} /> */}
      </div>
      <QbAnimationLoading
        isOpen={qbLoading}
        onClose={() => setQbLoading(false)}
      />
    </div>
  );
};

export default InvoicesFromQb;
